import type { CSSProperties } from 'react';
import type { CourseDraft } from './types';

function formatDate(value: string): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

interface AuditTrailSectionProps {
  draft: CourseDraft;
  styles: Record<string, CSSProperties>;
}

export function AuditTrailSection({ draft, styles }: AuditTrailSectionProps) {
  return (
    <section style={styles.card}>
      <div style={styles.cardHeader}>
        <h2 style={styles.cardTitle}>Audit trail</h2>
      </div>
      <div style={styles.cardBody}>
        <div style={styles.detailGrid}>
          <div>
            <div style={styles.detailLabel}>Created</div>
            <div style={styles.detailValue}>{formatDate(draft.createdAt)}</div>
          </div>
          <div>
            <div style={styles.detailLabel}>Created by</div>
            <div style={styles.detailValue}>{draft.createdByName || 'Unknown'}</div>
          </div>
          <div>
            <div style={styles.detailLabel}>Last updated</div>
            <div style={styles.detailValue}>{formatDate(draft.updatedAt)}</div>
          </div>
          <div>
            <div style={styles.detailLabel}>Updated by</div>
            <div style={styles.detailValue}>{draft.updatedByName || 'Unknown'}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
